import React, { useState } from "react";
import PopupConfirmarCancelar from "../popupConfirmarCancerlar/popupConfirmarCancerlar";
import "./botonEmergencia.css";

const BotonEmergencia = () => {
    const [mostrarPopup, setMostrarPopup] = useState(false);

    const handleEmergenciaClick = () => {
        setMostrarPopup(true);
    };

    const handleCerrarPopup = () => {
        setMostrarPopup(false);
    };

    const handleConfirmarLlamada = () => {
        setMostrarPopup(false);
        //abre la aplicación de llamadas con el numero de 4431135000
        window.open("tel:4431135000", "_self");
    };

    return (
        <>
            <button className="boton-emergencia" onClick={handleEmergenciaClick}>
                Emergencia
            </button>
            {mostrarPopup && (
                <PopupConfirmarCancelar
                    mensaje="La llamada puede ser grabada y monitoreada por su seguridad. ¿Desea continuar?"
                    onClose={handleCerrarPopup}
                    onConfirm={handleConfirmarLlamada}
                />
            )}
        </>
    );
};

export default BotonEmergencia;
